export default <TValue>(value: TValue[]) => value.filter(Boolean);
